import Vue from 'vue'
import router from "./router";
import App from './App.vue';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/style/variable.scss';
import i18n from "./system/lang/lang.js";
import VueMarqueeSlider from 'vue-marquee-slider';

Vue.use(BootstrapVue)
Vue.use(VueMarqueeSlider)
Vue.use(IconsPlugin)
Vue.config.productionTip = false

new Vue({
  methods: {  
    changeLan(lan) {
      const supported = ['zh', 'en', 'zh_hant', 'my', 'th', 'vn', 'ja', 'kr', 'rs'];
      if (supported.includes(lan)) {
        localStorage.setItem('lan', lan);
        this.$i18n.locale = lan;
      } else {
        this.makeToast('warning', this.$t('coming_soon'));
      }
    }
  },
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
